import {
	ArrowDown2 as _ArrowDown2,
	ArrowLeft2 as _ArrowLeft2,
	ArrowRight2 as _ArrowRight2,
	ArrowRotateLeft as _ArrowRotateLeft,
	ArrowSwapVertical as _ArrowSwapVertical,
	ArrowUp as _ArrowUp,
	Buildings as _Buildings,
	Calendar as _Calendar,
	Check as _Check,
	Clock as _Clock,
	CloseSquare as _CloseSquare,
	Crown as _Crown,
	Cup as _Cup,
	DocumentText as _DocumentText,
	Edit as _Edit,
	Eye as _Eye,
	EyeSlash as _EyeSlash,
	Game as _Game,
	Global as _Global,
	Grid1 as _Grid1,
	Link2 as _Link2,
	Location as _Location,
	Lock as _Lock,
	Logout as _Logout,
	Message as _Message,
	Moon as _Moon,
	More as _More,
	Profile as _Profile,
	Profile2User as _Profile2User,
	Refresh as _Refresh,
	Refresh2 as _Refresh2,
	SearchNormal1 as _SearchNormal1,
	Send as _Send,
	Setting as _Setting,
	Shield as _Shield,
	Sms as _Sms,
	Sun as _Sun,
	TickCircle as _TickCircle,
	TickSquare as _TickSquare,
	Timer as _Timer,
	Trash as _Trash,
	Verify as _Verify,
	VolumeHigh as _VolumeHigh,
	Warning2 as _Warning2,
	type Icon,
} from "iconsax-react";

/**
 * iconsax-react@0.0.8 supplies its defaults (color "currentColor", size 24,
 * variant "Linear") via `Component.defaultProps`. React 19 ignores
 * `defaultProps` on function components, so the raw icons render with
 * `color={undefined}` -> Linear strokes get no color and the icon is invisible.
 *
 * This barrel re-exports every icon used in the app with those defaults
 * injected as real props. Import iconsax icons from "@/lib/iconsax", never
 * from "iconsax-react" directly.
 */
function withDefaults(Inner: Icon, name: string): Icon {
	const Wrapped: Icon = (props) => (
		<Inner color="currentColor" size={24} variant="Linear" {...props} />
	);
	Wrapped.displayName = name;
	return Wrapped;
}

export const ArrowDown2: Icon = withDefaults(_ArrowDown2, "ArrowDown2");
export const ArrowLeft2: Icon = withDefaults(_ArrowLeft2, "ArrowLeft2");
export const ArrowRight2: Icon = withDefaults(_ArrowRight2, "ArrowRight2");
export const ArrowRotateLeft: Icon = withDefaults(_ArrowRotateLeft, "ArrowRotateLeft");
export const ArrowSwapVertical: Icon = withDefaults(_ArrowSwapVertical, "ArrowSwapVertical");
export const ArrowUp: Icon = withDefaults(_ArrowUp, "ArrowUp");
export const Buildings: Icon = withDefaults(_Buildings, "Buildings");
export const Calendar: Icon = withDefaults(_Calendar, "Calendar");
export const Clock: Icon = withDefaults(_Clock, "Clock");
export const Message: Icon = withDefaults(_Message, "Message");
export const Check: Icon = withDefaults(_Check, "Check");
export const CloseSquare: Icon = withDefaults(_CloseSquare, "CloseSquare");
export const Crown: Icon = withDefaults(_Crown, "Crown");
export const Cup: Icon = withDefaults(_Cup, "Cup");
export const DocumentText: Icon = withDefaults(_DocumentText, "DocumentText");
export const Edit: Icon = withDefaults(_Edit, "Edit");
export const Eye: Icon = withDefaults(_Eye, "Eye");
export const EyeSlash: Icon = withDefaults(_EyeSlash, "EyeSlash");
export const Game: Icon = withDefaults(_Game, "Game");
export const Global: Icon = withDefaults(_Global, "Global");
export const Grid1: Icon = withDefaults(_Grid1, "Grid1");
export const Link2: Icon = withDefaults(_Link2, "Link2");
export const Location: Icon = withDefaults(_Location, "Location");
export const Lock: Icon = withDefaults(_Lock, "Lock");
export const Logout: Icon = withDefaults(_Logout, "Logout");
export const Moon: Icon = withDefaults(_Moon, "Moon");
export const More: Icon = withDefaults(_More, "More");
export const Profile: Icon = withDefaults(_Profile, "Profile");
export const Profile2User: Icon = withDefaults(_Profile2User, "Profile2User");
export const Refresh: Icon = withDefaults(_Refresh, "Refresh");
export const Refresh2: Icon = withDefaults(_Refresh2, "Refresh2");
export const SearchNormal1: Icon = withDefaults(_SearchNormal1, "SearchNormal1");
export const Send: Icon = withDefaults(_Send, "Send");
export const Setting: Icon = withDefaults(_Setting, "Setting");
export const Shield: Icon = withDefaults(_Shield, "Shield");
export const Sms: Icon = withDefaults(_Sms, "Sms");
export const Sun: Icon = withDefaults(_Sun, "Sun");
export const TickCircle: Icon = withDefaults(_TickCircle, "TickCircle");
export const TickSquare: Icon = withDefaults(_TickSquare, "TickSquare");
export const Timer: Icon = withDefaults(_Timer, "Timer");
export const Trash: Icon = withDefaults(_Trash, "Trash");
export const Verify: Icon = withDefaults(_Verify, "Verify");
export const VolumeHigh: Icon = withDefaults(_VolumeHigh, "VolumeHigh");
export const Warning2: Icon = withDefaults(_Warning2, "Warning2");

export type { Icon, IconProps } from "iconsax-react";
